var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 63",
    style: {
      enableBackground: "new 0 0 86 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#58FDD9;}\n\t.st1{fill:#FCFCFC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(96.000000, 1712.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -95.7,
    y: -1692.6,
    className: "st0",
    width: 83.3,
    height: 12.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M-24.3-1676.5c-4.1,0-7.3,3.4-7.3,7.7s3.2,7.7,7.3,7.7s7.3-3.4,7.3-7.7S-20.2-1676.5-24.3-1676.5 z M-24.3-1664.4c-2.6,0-4.7-1.9-4.7-4.4s2-4.4,4.7-4.4c2.6,0,4.7,1.9,4.7,4.4S-21.7-1664.4-24.3-1664.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000029028742543878821040000012347709116181602703_",
    className: "st1",
    d: "M-89.6-1649h71.2c4.2,0,7.4-3.3,7.4-7.5 v-30v-12v-6c0-4.2-3.3-7.5-7.4-7.5h-71.2c-4.2,0-7.4,3.3-7.4,7.5v6v12v30C-97-1652.3-93.7-1649-89.6-1649z M-18.1-1652.4h-71.7 c-2.5,0-4.5-1.9-4.5-4.5v-28.4h80.7v28.4C-13.7-1654.3-15.6-1652.4-18.1-1652.4z M-94.3-1697.3h80.7v9.4h-80.7V-1697.3z  M-89.9-1709.3h71.7c2.5,0,4.5,2,4.5,4.7v4.7h-80.7v-4.7C-94.3-1707.3-92.4-1709.3-89.9-1709.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M-83.8-1664.4h-5.8c-0.9,0-1.4,0.7-1.4,1.7c0,1,0.6,1.7,1.4,1.7h5.8c0.9,0,1.4-0.7,1.4-1.7 C-82.3-1663.7-82.9-1664.4-83.8-1664.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000074403423952420325510000017488940698629577096_",
    className: "st1",
    d: "M-71.8-1664.4h-5.8c-0.9,0-1.4,0.7-1.4,1.7 c0,1,0.6,1.7,1.4,1.7h5.8c0.9,0,1.4-0.7,1.4-1.7C-70.3-1663.7-70.9-1664.4-71.8-1664.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000058572427743514178820000001088419001677621434_",
    className: "st1",
    d: "M-59.8-1664.4h-5.8c-0.9,0-1.4,0.7-1.4,1.7 c0,1,0.6,1.7,1.4,1.7h5.8c0.9,0,1.4-0.7,1.4-1.7C-58.3-1663.7-58.9-1664.4-59.8-1664.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000093858000914306808420000002866606202200466820_",
    className: "st1",
    d: "M-47.9-1664.4h-6.2c-0.9,0-1.6,0.7-1.6,1.7 c0,1,0.6,1.7,1.6,1.7h6.2c0.9,0,1.6-0.7,1.6-1.7C-46.3-1663.7-47-1664.4-47.9-1664.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000080194342236417044080000016310493524553612455_",
    className: "st1",
    d: "M-89.5-1667.1h23.7c0.9,0,1.5-0.7,1.5-1.7 c0-1-0.6-1.7-1.5-1.7h-23.7c-0.9,0-1.5,0.7-1.5,1.7C-91-1667.8-90.4-1667.1-89.5-1667.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.bf7cc453b4a12a038b3ed0106ac263d2.svg";
export { ForwardRef as ReactComponent };